module.exports = __webpack_public_path__ + "static/img/index-bg.a302150f.png";